var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "upgrade-strategy popbox",
          attrs: {
            name: "dialog2",
            title: "添加规则",
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.showopen,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { label: "升级策略类型", prop: "strategy_type" } },
                [
                  _c("v-select", {
                    attrs: {
                      id: "strategy_type",
                      insertContains: "strategy_type",
                      name: "strategy_type",
                      disabled: _vm.isEdit,
                      options: _vm.upgradeTypeOptions,
                    },
                    on: { change: _vm.handleStrategyTypeChange },
                    model: {
                      value: _vm.ruleForm.strategy_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "strategy_type", $$v)
                      },
                      expression: "ruleForm.strategy_type",
                    },
                  }),
                ],
                1
              ),
              _vm.ruleForm.strategy_type === "baseproduct"
                ? _c(
                    "v-form-item",
                    { attrs: { label: "产品名称", prop: "product_key" } },
                    [
                      _c("v-select", {
                        attrs: {
                          "is-search": "",
                          name: "product_key",
                          id: "product_key",
                          insertContains: "product_key",
                          options: _vm.productKeyOptins,
                          disabled: _vm.isEdit,
                        },
                        on: { change: _vm.handleProductChange },
                        model: {
                          value: _vm.ruleForm.product_key,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "product_key", $$v)
                          },
                          expression: "ruleForm.product_key",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ruleForm.strategy_type !== "basesn"
                ? _c(
                    "v-form-item",
                    { attrs: { label: "源版本", prop: "source_ver_id" } },
                    [
                      _c("v-select", {
                        attrs: {
                          "is-search": "",
                          name: "source_ver_id",
                          id: "source_ver_id",
                          insertContains: "source_ver_id",
                          options: _vm.resverOptions,
                          disabled: _vm.isEdit,
                        },
                        model: {
                          value: _vm.ruleForm.source_ver_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "source_ver_id", $$v)
                          },
                          expression: "ruleForm.source_ver_id",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-form-item",
                { attrs: { label: "目标版本", prop: "target_ver_id" } },
                [
                  _c("v-select", {
                    attrs: {
                      "is-search": "",
                      name: "target_ver_id",
                      id: "target_ver_id",
                      insertContains: "target_ver_id",
                      options: _vm.resverOptions,
                      disabled: _vm.isEdit,
                    },
                    model: {
                      value: _vm.ruleForm.target_ver_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "target_ver_id", $$v)
                      },
                      expression: "ruleForm.target_ver_id",
                    },
                  }),
                ],
                1
              ),
              _vm.ruleForm.strategy_type === "baseproduct"
                ? _c(
                    "v-form-item",
                    { attrs: { label: "策略文件选择", prop: "has_file" } },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "has_file",
                          id: "has_file",
                          insertContains: "has_file",
                          options: _vm.fileOptions,
                          disabled: _vm.isEdit,
                        },
                        model: {
                          value: _vm.ruleForm.has_file,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "has_file", $$v)
                          },
                          expression: "ruleForm.has_file",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.ruleForm.has_file === 1
                ? _c(
                    "v-form-item",
                    {
                      staticClass: "listfile",
                      attrs: {
                        label: "策略文件",
                        required: false,
                        prop: "listFile",
                      },
                    },
                    [
                      _c("v-upload", {
                        ref: "upload",
                        attrs: {
                          action: "/cgi-bin/upload",
                          name: "upload",
                          accept: ".txt,.bin",
                          WfileName: _vm.fileName,
                          "show-file-list": "",
                          "on-change": _vm.hidemsg,
                          noName: _vm.noName,
                          disabled: _vm.isEdit,
                        },
                        on: { showtips: _vm.showfiletips },
                      }),
                      _c("span", { staticClass: "tips" }, [
                        _vm._v("文件内容格式为: "),
                        _c("span", { staticClass: "tipsspan" }, [
                          _vm._v("KEY1 "),
                          _c("div", { staticClass: "setsn1" }, [
                            _vm._v("KEY2"),
                          ]),
                          _c("div", { staticClass: "setsn2" }, [_vm._v("...")]),
                        ]),
                      ]),
                      _c(
                        "span",
                        { staticClass: "toptip" },
                        [
                          _c(
                            "v-col",
                            { attrs: { offset: 1, span: 2 } },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    "max-width": 210,
                                    content:
                                      "添加此策略使上传文件内的KEY与指定版本绑定，使拥有这些KEY的设备们在升级时可以升级到此指定版本",
                                    trigger: "click",
                                    position: "top-center",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/tips.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { ref: "filetip", staticClass: "filetip" }, [
                        _vm._v("未选择文件"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-form-item",
                { attrs: { label: "升级时间", prop: "upgrade_type" } },
                [
                  _c("v-select", {
                    attrs: {
                      id: "upgrade_type",
                      insertContains: "upgrade_type",
                      name: "upgrade_type",
                      options: _vm.upgradeTimeOptions,
                      disabled: _vm.isEdit,
                    },
                    model: {
                      value: _vm.ruleForm.upgrade_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "upgrade_type", $$v)
                      },
                      expression: "ruleForm.upgrade_type",
                    },
                  }),
                  _vm.ruleForm.upgrade_type === 1
                    ? _c("p", { staticClass: "desc" }, [
                        _vm._v("注：升级时间的策略需设备适配"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm.ruleForm.upgrade_type === 2
                ? _c(
                    "v-form-item",
                    { attrs: { label: "升级时间段", prop: "time" } },
                    [
                      _c("v-timepicker", {
                        attrs: {
                          "is-range": "",
                          value: [
                            _vm.ruleForm.start_time,
                            _vm.ruleForm.end_time,
                          ],
                          placeholder: "开始时间",
                          endPlaceholder: "结束时间",
                          disabled: _vm.isEdit,
                        },
                        on: { change: _vm.handleTimeChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-form-item",
                { attrs: { label: "备注", prop: "memo", required: false } },
                [
                  _c("v-input", {
                    staticClass: "remarks",
                    attrs: {
                      type: "textarea",
                      name: "memo",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.memo,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "memo", $$v)
                      },
                      expression: "ruleForm.memo",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "desc",
                      style: { verticalAlign: "top", paddingLeft: "8px" },
                    },
                    [_vm._v("可选")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }